const heb = () => {
  return {
    global: {
      next: 'הבא',
      requiredField: 'שדה חובה',
      signUp: 'הרשמה',
      finish: 'סיום',
      letsGo: 'סיום',
    },
    selectInput: {
      search: 'חפש...',
      notFound: 'אין תוצאות',
    },
    signUp: {
      removeSpecialChars: 'אנא הסירו תווים מיוחדים',
      credentialsPage: {
        haveAccount: 'יש לכם כבר חשבון?',
        clickHere: 'לחצו כאן',
        headline: 'הרשמו עכשיו בחינם!',
        passwordDesc: 'הסיסמה חייבת להכיל לפחות שמונה תווים, אות אחת ומספר אחד',
        email: 'כתובת מייל',
        password: 'סיסמה',
        telephone: 'טלפון',
        emailError: {
          exist: 'שם משתמש קיים במערכת',
          invalid: 'דוא"ל לא חוקי',
        },
        passwordError: {
          length: 'הסיסמה חייבת להיות לפחות 5 תווים',
        },
      },
      businessType: {
        sales: 'מכירות',
        realEstate: 'נדל"ן',
        education: 'אקדמיה',
        media: 'מדיה',
        insurance: 'ביטוח',
        healthCare: 'רפואה ובריאות',
        finance: 'פיננסים',
        headline: 'מה הטעם שלך?',
        secondaryHeadline: 'בחר סוג ארגון',
        other: 'אחר',
      },
      templateAndCompanySize: {
        headline: 'התאימו את המערכת לצרכים שלכם!',
        industryType: 'בחרו תבנית מותאמת לסוג החברה',
        companySize: 'כמה עובדים יש בחברה?',
        weDo: 'בחרו תבנית',
        companyName: 'מה שם החברה שלכם?',
      },
      personalDetails: {
        headline: 'ספרו לנו עוד על עצמכם כדי שנוכל להכיר באמת.',
        bySigning: 'בהרשמה הינכם מסכימים',
        and: 'ול',
        privacy: 'מדיניות הפרטיות',
        terms: 'לתנאי השירות',
        fullName: 'שם מלא',
        companyName: 'שם חברה',
      },
      creatingScreen: {
        almostThere: 'אנחנו כמעט שם!',
        sitTight: 'אנחנו בונים לכם את המערכת',
        dashboards: 'אנחנו מגדירים את לוחות הבקרה שלכם',
        accounts: 'אנחנו יוצרים את הלקוחות שלכם',
        workflows: 'אנחנו מייצרים את תהליכי העבודה שלכם',
      },
    },
    positionType: {
      management: 'הנהלה',
      sales: 'מכירות',
      service: 'שירות',
      marketing: 'שיווק',
      hrAndOp: 'כוח אדם ותפעול',
      finance: 'כספים',
      other: 'אחר',
    },
  };
};

export default heb;
